import * as _ from 'lodash';

export class CompanyGroupsFinancial {
    _id: String;
    name: String;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadFromServer(r: any) {
        if (r._id != undefined)
            this._id = r._id;

        if (r.name != undefined)
            this.name = r.name;

    }
}


// WEBPACK FOOTER //
// ./src/app/models/project/CompanyGroupsFinancial.model.ts